import OrderedListMenu from 'src/views/ordered-list-menu';

const template = require('./edit-ordered-list.hbs');

module.exports = Backbone.View.extend({
  orderedLevel: 0,
  orderedStart: 1,
  orderedStyle: 0,
  orderedWidth: 0,
  orderedNumberingStyle: 0,
  orderedRegex: '',
  isContinueFromPrevious: true,

  initialize: function (options) {
    this.element = options.selectedElement;

    const textArea = new INKIVE.Text.Textarea().setDOM(this.element, false);
    const textOrderedStyle = textArea.text.strings.filter(string => string.isEol).map(string => string.orderedStyle);
    const textOrderedStart = textArea.text.strings.filter(string => string.isEol).map(string => string.orderedStart);
    const textOrderedWidth = textArea.text.strings.filter(string => string.isEol).map(string => string.orderedWidth);
    const textOrderedNumberingStyle = textArea.text.strings.filter(string => string.isEol).map(string => string.orderedNumberingStyle);
    const textOrderedRegex = textArea.text.strings.filter(string => string.isEol).map(string => string.orderedRegex);

    this.orderedLevel = document.querySelector('.btn[data-action="on_set-list"]')?.classList?.contains('applied') ? 1 : 0;
    this.orderedStart = textOrderedStart[0] || 1;
    this.orderedStyle = new Set(textOrderedStyle).size === 1 && textOrderedStyle[0] ? textOrderedStyle[0] : 0;
    this.orderedNumberingStyle = new Set(textOrderedNumberingStyle).size === 1 && textOrderedNumberingStyle[0] ? textOrderedNumberingStyle[0] : 0;
    this.orderedWidth = new Set(textOrderedWidth).size === 1 && textOrderedWidth[0] ? textOrderedWidth[0] : 0;
    this.orderedRegex = new Set(textOrderedRegex).size === 1 && textOrderedRegex[0] ? textOrderedRegex[0] : '';
    this.isContinueFromPrevious = !textOrderedStart[0];

    this.$el.html(template());
    OrderedListMenu.mountApp(this, textArea);
  }
});
